import { render, staticRenderFns } from "./ProjCreate.vue?vue&type=template&id=3d9aa727&"
import script from "./ProjCreate.vue?vue&type=script&lang=js&"
export * from "./ProjCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports